import { View } from '@react-pdf/renderer'

export const Header: React.FC = () => {
  return (
        <View style={{ backgroundColor: '#66046B', height: '32px' }}>
        </View>
  )
}
